<div id="scrollUp" title="Scroll To Top">
    <i class="fas fa-arrow-up"></i>
</div>